module.exports = __webpack_public_path__ + "media/images/rank/gold-lg-6c6586986f0bf56d8003a3fce68e1d42.svg";